<!-- 合同应收 主从 -->
<template>
  <div>
    <upperMasterLowerSlave
      ref="columnTables"
      @master-data-loaded="getMsterTableData"
      @slave-data-loaded="getSlaveTableData"
      @row-click="onRowClick"
      @first-row="onFirstRow"
      :zbParams="{
        opId: 6100000098,
        dataClass: 1,
        tableHeight: 500,
        filterObj: filterObj
      }"
      :cbParams="{
        opId: 6100000098,
        dataClass: 2,
        tableHeight: 400,
        searchHidden: true,
        topButtonArea: topButtonVisible
      }"
      :zcbGlgx="{
        parProp: 'RCVMSTID',
        chilProp: 'RCVMSTID'
      }"
    >
      <template slot="RIGHT_BUTTON">
        <el-button type="primary" size="small" @click="clearFilter"
          >清除合同管理筛选</el-button
        >
      </template>
    </upperMasterLowerSlave>
  </div>
</template>

<script>
import upperMasterLowerSlave from "@/components/table/newTemplate/upperMasterLowerSlave";
import axios from "axios";
export default {
  components: {
    upperMasterLowerSlave
  },
  data() {
    return {
      filterObj: {
        CONMSTID: this.$route.query.CONMSTID
      },
      hasSelectedRow: false,
      topButtonVisible: false,
      currentMasterRow:{},
    };
  },
  methods: {
    // getSlaveTableData(data) {
    //   const slaveTable = this.$refs.columnTables.$refs.slave.$refs.child;
    //   if (this.hasSelectedRow) {
    //     this.$set(slaveTable.allOption, "topButtonArea", true);
    //   } else {
    //     this.$set(slaveTable.allOption, "topButtonArea", false);
    //   }
    // },
    // 目的是在从表加载完数据后，将主表选择的数据增加到addform中，用于从表字段的回填
    getSlaveTableData(data) {
      this.slaveTableData = data || [];
      // 从表数据加载完成后（父组件重渲染已结束），重新设置 addForm
      console.log("getSlaveTableData", data);
      if (this.currentMasterRow) {
        this.$nextTick(() => {
          this.updateSlaveAddForm(this.currentMasterRow);
        });
      }
    },

    // 首次加载数据时，存储首行并同步主表数据到从表addForm
    onFirstRow(row) {
      this.currentMasterRow = row;
      console.log("首次加载数据时，存储首行", row);
      this.updateSlaveAddForm(row);
    },
    onRowClick(row) {
      // const slaveTable = this.$refs.columnTables.$refs.slave.$refs.child;
      // this.$set(slaveTable.option, "topButtonArea", true);
      //this.$refs.columnTables.cbtopButtonArea = true;     // ① 改 data,绕过 prop
      //this.$refs.columnTables.$forceUpdate();              // ② 强制重渲染
      console.log('[父] onRowClick 触发, 获取当前行数据:', row);
      console.log('[父] onRowClick 触发, 改 topButtonVisible = true');
      this.topButtonVisible = true;
      console.log('[父] 改完后 topButtonVisible =', this.topButtonVisible);
      this.currentMasterRow = row;
      console.log("点击其他行后，行数据是", row);
      this.updateSlaveAddForm(row);
      console.log("查看zcbGlgx", this.$refs.columnTables.zcbGlgx);
    },

    // 更新从表新增弹窗的默认值（将主表字段传入从表addForm）
    updateSlaveAddForm(row) {
      console.log("更新从表新增弹窗传入的主表行为", row);
      // 需要CONMSTID和YIYUANDM
      const slaveColObj = this.$refs.columnTables.$refs.slave.colObj;
      if (slaveColObj) {
        console.log("主表是否有医院代码", row.YIYUANDM);
        if (row.YIYUANDM) { // 有值时，将yiyuandm传入限制slave1对应字段不可选其他
          slaveColObj.addForm = {
            RCVMSTID: row.RCVMSTID,
            YIYUANDM: row.YIYUANDM 
          };
        } else {
          slaveColObj.addForm = { RCVMSTID: row.RCVMSTID };
        }
      }
      console.log("更新从表新增弹窗的默认值", slaveColObj.addForm);
    },
    clearFilter() {
      console.log("当前的合同管理筛选", this.filterObj);
      this.filterObj = {};
      setTimeout(() => {
        this.$refs.columnTables.$refs.master.$refs.child.onLoad();
      }, 100);
      console.log("清除后的合同管理筛选", this.filterObj);
    }
  },
  watch: {
    "$route.query.CONMSTID"(newVal) {
      this.filterObj = { CONMSTID: newVal };
      this.$nextTick(() => {
        this.$refs.columnTables.$refs.master.$refs.child.onLoad();
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
